var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1959_3528)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.0005 17.0453V24.7908H30.7641C30.2914 27.2817 28.8731 29.3908 26.7458 30.809L33.2367 35.8454C37.0185 32.3546 39.2003 27.2273 39.2003 21.1364C39.2003 19.7182 39.0731 18.3545 38.8367 17.0455L20.0005 17.0453Z",
    fill: "url(#paint0_linear_1959_3528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.79074 24.4881L7.3268 25.6087L2.1449 29.645C5.4358 36.1722 12.1808 40.6814 19.9989 40.6814C25.3987 40.6814 29.9259 38.8996 33.2351 35.8451L26.7442 30.8087C24.9624 32.0087 22.6897 32.736 19.9989 32.736C14.7989 32.736 10.3808 29.227 8.79892 24.4996L8.79074 24.4881Z",
    fill: "url(#paint1_linear_1959_3528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.1453 11.7181C0.781737 14.4089 0 17.4453 0 20.6817C0 23.918 0.781737 26.9544 2.1453 29.6452C2.1453 29.6632 8.79996 24.4815 8.79996 24.4815C8.39996 23.2815 8.16353 22.0089 8.16353 20.6814C8.16353 19.354 8.39996 18.0814 8.79996 16.8814L2.1453 11.7181Z",
    fill: "url(#paint2_linear_1959_3528)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.9993 8.64552C22.9448 8.64552 25.5629 9.66367 27.6538 11.6273L33.381 5.90013C29.9083 2.66383 25.3994 0.681885 19.9993 0.681885C12.1812 0.681885 5.4358 5.17279 2.1449 11.7183L8.79935 16.8819C10.3811 12.1546 14.7993 8.64552 19.9993 8.64552Z",
    fill: "url(#paint3_linear_1959_3528)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1959_3528",
    x1: 20.0005,
    y1: 26.4453,
    x2: 39.2003,
    y2: 26.4453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1959_3528",
    x1: 2.1449,
    y1: 32.5847,
    x2: 33.2351,
    y2: 32.5847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1959_3528",
    x1: 0,
    y1: 20.6817,
    x2: 8.79996,
    y2: 20.6817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1959_3528",
    x1: 2.1449,
    y1: 8.78189,
    x2: 33.381,
    y2: 8.78189,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#53584C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1A68D"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1959_3528"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white",
    transform: "translate(0 0.681885)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/GoogleIcon.f321bbcd9f846ae2b94f1ebde6c0a62d.svg";
export { ForwardRef as ReactComponent };